<template>
  <div>
    <el-header class="hidden-sm-and-down header_pc" height="218px">
      <el-row class="head_dingbu">
        <headall>
          <slot>
            <span class="head_text">仪海仪家</span>
            <img class="head_dingwei" src="../../assets/home/dingwei.png" />
            <span class="head_text head_text_cao_left">
              HI!{{
                $store.state.information != ""
                  ? $store.state.information.name
                  : ""
              }}
            </span>
            <el-tooltip>
              <div slot="content">
                <img
                  src="../../assets/home/xiaochengxu.jpg"
                  class="img-xiaochengxu"
                  style="width: 150px; height: 150px"
                />
              </div>
              <span class="head_text head_text_xiaoxi_left">
                <li class="el-icon-mobile-phone"></li>
                手机扫一扫</span
              >
            </el-tooltip>
            
            <!-- <span v-if="total_xi == 0"> -->
            <!-- <el-button type="text" size="small"
                             @click="chat_list"
                             style="margin-left: 50px;
                             font-family: Source Han Sans CN;
                             color: #333333;">仪小星
                  </el-button> -->
            <template v-if="total_xi == 0">
              <div class="yixiaoxing">
                <img
                  src="../../assets/home/yixiaoxing1.png"
                  alt=""
                  class="image"
                  @click="chat_list"
                />
              </div>
            </template>

            <!-- </span> -->
            <el-badge v-else :value="total_xi" class="item">
              <div class="yixiaoxing">
                <img
                  src="../../assets/home/yixiaoxing1.png"
                  alt=""
                  class="image"
                  @click="chat_list"
                />            
              </div>
            </el-badge>

            
          </slot>
        </headall>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
          <div class="head_width">
            <div class="header_logo_top">
              <el-row>
                <el-col :lg="8" :md="5" :sm="8" :xl="8" :xs="8">
                  <a class="xuanzhong wenzi" href="">
                    <img class="header_logo" src="../../assets/home/logo.png" />
                  </a>
                </el-col>
                <el-col :lg="16" :md="19" :sm="16" :xl="16" :xs="16">
                  <div class="header_sousuo">
                    <img
                      class="header_sousuo_logo"
                      src="../../assets/home/sousuo_logo.png"
                    />
                    <div
                      :class="
                        is_open.sousuo == 1
                          ? 'header_sousuo_tuijian_xuanzhong'
                          : ''
                      "
                      @click="sousuo_xuanxiang(1)"
                      class="header_sousuo_tuijian"
                    >
                      找商品
                    </div>
                    <div
                      :class="
                        is_open.sousuo == 2
                          ? 'header_sousuo_tuijian_xuanzhong'
                          : ''
                      "
                      @click="sousuo_xuanxiang(2)"
                      class="header_sousuo_tuijian header_sousuo_tuijian_2"
                    >
                      找服务
                    </div>
                    <div
                      :class="
                        is_open.sousuo == 3
                          ? 'header_sousuo_tuijian_xuanzhong'
                          : ''
                      "
                      @click="sousuo_xuanxiang(3)"
                      class="header_sousuo_tuijian header_sousuo_tuijian_3"
                    >
                      仪小星讲堂
                    </div>
                    <input
                      style="
                        background: none;
                        outline: none;
                        border: none;
                        height: 100%;
                        width: 450px;
                      "
                      v-model="is_open.search_text"
                    />
                  </div>
                  <button @click="do_search()" class="header_sousuo_button">
                    <a href="javascript:void(0)" style="color: #ffffff">搜索</a>
                  </button>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
                <div class="header_gongye_lianjie">
                  <div
                    class="header_gongye_kuang"
                    v-if="
                      is_product_path ||
                      is_service_path ||
                      is_product_path_no_menu ||
                      is_service_path_no_menu
                    "
                  >
                    <div
                      @click="is_open.lanmu = 1"
                      class="header_gongye_kuang_text"
                      v-if="is_product_path || is_product_path_no_menu"
                    >
                      <img
                        alt=""
                        src="../../assets/home/gongye.png"
                        v-if="is_product_path_no_menu"
                        style="margin-right: 12px"
                      />
                      工业产品
                    </div>
                    <div
                      @click="is_open.lanmu = 2"
                      class="header_gongye_kuang_text"
                      v-if="is_service_path || is_service_path_no_menu"
                    >
                      专业服务
                    </div>
                    <!--
                      <div class="header_gongye_kuang_text "
                           v-if="is_product_path_no_menu">
                          <img alt="" src="../../assets/home/gongye.png"
                               style="margin-right: 12px">
                          工业产品
                      </div>
                      <div class="header_gongye_kuang_text "
                           v-if="is_service_path_no_menu">
                          专业服务
                      </div>
                    -->
                    <div
                      :class="{ hidden: !is_product_path || !is_service_path }"
                      class="header_gongye_kuang_zhuangtai2"
                      style="margin-left: 37px"
                      v-if="is_open.lanmu === 1"
                    ></div>
                    <div
                      :class="{ hidden: !is_product_path || !is_service_path }"
                      class="header_gongye_kuang_zhuangtai2"
                      v-if="is_open.lanmu === 2"
                    ></div>
                    <div class="clear"></div>
                    <el-row
                      class="m-t10"
                      v-if="is_product_path || is_service_path"
                    >
                      <el-col :lg="5" :md="7" :sm="7" :xl="5" :xs="24">
                        <!--                        专业服务-->
                        <div
                          class="main_fenlan_neirong"
                          v-if="is_open.lanmu == 2"
                        >
                          <div
                            class="main_fenlan_neirong_list"
                            v-for="(item1, index1) in daohang1"
                            v-bind:key="index1"
                          >
                            <a class="xuanzhong wenzi" :href="item1.link">
                              <el-popover
                                placement="right"
                                width="600"
                                trigger="hover"
                              >
                                <span class="pop-list"
                                  v-for="(item5, index5) in zixiang_fuwu"
                                  :key="index5"
                                >
                                  <template v-for="(item6, index6) in item5" >
                                    <span class="pop-list-item" :key="index6" v-if="item1.id == item6.pid">
                                      <a
                                        :href="item6.link"
                                        style="text-decoration: none"
                                      >
                                        <template v-if="item1.id == item6.pid">
                                          <span
                                            style="
                                              margin-left: 20px;
                                              color: #5c5959;
                                              font-weight: bolder;
                                            "
                                            >{{ item6.name }}</span
                                          >
                                        </template>
                                      </a>
                                    </span>
                                  </template>  
                                  
                                </span>
                                <el-button
                                  type="text"
                                  slot="reference"
                                  v-if="item1.position == 'cebian'"
                                  class="main_fenlan_neirong_list_text"
                                >
                                  {{ item1.name }}
                                </el-button>
                              </el-popover>
                            </a>
                          </div>
                        </div>

                        <!--                        工业产品-->
                        <div
                          class="main_fenlan_neirong"
                          v-if="is_open.lanmu == 1"
                        >
                          <div
                            class="main_fenlan_neirong_list"
                            v-for="(item2, index2) in daohang2"
                            v-bind:key="index2"
                          >
                            <a class="xuanzhong wenzi" :href="item2.link">
                              <el-popover
                                placement="right"
                                width="600"
                                trigger="hover"
                                transition
                              >
                                <span class="pop-list"
                                  v-for="(item3, index3) in zixiang"
                                  :key="index3"
                                >
                                <template v-for="(item4, index4) in item3" >
                                  <span class="pop-list-item" :key="index4"  v-if="item2.id == item4.pid">
                                   <a :href="item4.link" style="text-decoration: none">
                                      <template v-if="item2.id == item4.pid">
                                          <span
                                            style="
                                              margin-left: 20px;
                                              color: #5c5959;
                                              font-weight: bolder;
                                            "
                                            >{{ item4.name }}</span
                                          >
                                        </template>
                                   </a>
                                    
                                      
                                      
                                    
                                  </span>
                                </template>
                                  
                                </span>
                                <el-button
                                  type="text"
                                  slot="reference"
                                  v-if="item2.position == 'cebian'"
                                  class="main_fenlan_neirong_list_text"
                                >
                                  {{ item2.name }}
                                </el-button>
                              </el-popover>
                            </a>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                  <el-menu
                    :default-active="activeIndex"
                    @select="handleSelect"
                    class="el-menu-demo"
                    mode="horizontal"
                    style="
                      width: 265px;
                      float: left;
                      height: 37px;
                      background-color: #4e6ef2;
                      border-radius: 5px 5px 0px 0px;
                    "
                    v-if="is_both_path"
                  >
                    <el-submenu index="1">
                      <template slot="title">工业产品</template>
                      <div class="main_fenlan_neirong1">
                        <div
                          class="main_fenlan_neirong_list"
                          v-for="(item2, index2) in daohang2"
                          v-bind:key="index2"
                        >
                          <a class="xuanzhong wenzi" :href="item2.link">
                            <el-popover
                              placement="right"
                              width="600"
                              trigger="hover"
                              transition
                            >
                              <span class="pop-list"
                                v-for="(item3, index3) in zixiang"
                                :key="index3"
                              >
                              <template v-for="(item4, index4) in item3" >
                                <span class="pop-list-item" :key="index4" v-if="item2.id == item4.pid" >
                                  <a
                                    :href="item4.link"
                                    style="text-decoration: none"
                                  >
                                    <template v-if="item2.id == item4.pid">
                                      <span
                                        style="
                                          margin-left: 20px;
                                          color: #5c5959;
                                          font-weight: bolder;
                                        "
                                        >{{ item4.name }}</span
                                      >
                                    </template>
                                  </a>
                                </span>
                              </template>
                                
                              </span>
                              <el-button
                                type="text"
                                slot="reference"
                                v-if="item2.position == 'cebian'"
                                class="main_fenlan_neirong_list_text"
                              >
                                {{ item2.name }}
                              </el-button>
                            </el-popover>
                          </a>
                        </div>
                      </div>
                    </el-submenu>

                    <el-submenu index="2">
                      <template slot="title">专业服务</template>
                      <div class="main_fenlan_neirong1">
                        <div
                          class="main_fenlan_neirong_list"
                          v-for="(item1, index1) in daohang1"
                          v-bind:key="index1"
                        >
                          <a class="xuanzhong wenzi" :href="item1.link">
                            <el-popover
                              placement="right"
                              width="600"
                              trigger="hover"
                            >
                              <span class="pop-list"
                                v-for="(item5, index5) in zixiang_fuwu"
                                :key="index5"
                              >
                              <template v-for="(item6, index6) in item5" >
                                <span class="pop-list-item"  :key="index6" v-if="item1.id == item6.pid" >
                                  <a
                                    :href="item6.link"
                                    style="text-decoration: none"
                                  >
                                    <template v-if="item1.id == item6.pid">
                                      <span
                                        style="
                                          margin-left: 20px;
                                          color: #5c5959;
                                          font-weight: bolder;
                                        "
                                        >{{ item6.name }}</span
                                      >
                                    </template>
                                  </a>
                                </span>
                              </template>

                                
                              </span>
                              <el-button
                                type="text"
                                slot="reference"
                                v-if="item1.position == 'cebian'"
                                class="main_fenlan_neirong_list_text"
                              >
                                {{ item1.name }}
                              </el-button>
                            </el-popover>
                          </a>
                        </div>
                      </div>
                    </el-submenu>
                  </el-menu>

                  <div v-for="(item, index) in daohang" v-bind:key="index">
                    <a class="xuanzhong wenzi" :href="item.link">
                      <div
                        v-if="item.position == 'dingbu'"
                        class="header_gongye_lianjie_qiota"
                      >
                        {{ item.name }}
                      </div>
                    </a>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-header class="hidden-sm-and-up header_phone" height="38px">
      <span class="header_phone_name">仪海仪家</span>
      <img class="head_phone_dingwei" src="../../assets/home/dingwei.png" />
      <span class="head_phone_huanyi"
        >HI!{{
          $store.state.information != ""
            ? $store.state.information.name
            : "您好"
        }}</span
      >
      <img class="head_phone_xiaoxi_img" src="../../assets/home/xiaoxi.png" />
      <span class="head_phone_xiaoxi">消息</span>
      <span class="head_phone_zhuce">{{
        $store.state.information != "" ? "" : "[免费注册]"
      }}</span>
      <span class="head_phone_denglu">{{
        $store.state.information != "" ? "" : "[登录]"
      }}</span>
    </el-header>
  </div>
</template>

<script>
import headall from "./head";
export default {
  name: "home-head",
  components: {
    headall,
  },
  data: function () {
    return {
      is_open: {
        sousuo: 1,
        search_text: "",
        lanmu: 1,
        phone_shaixuan: 0,
        phone_sousuokuang: 0,
      },
      // config:{
      //     email   : '',
      //     phone   : '',
      // },
      activeIndex: "1",

      path_product: ["home", "juyishangcheng"],
      path_product_no_menu: ["goods_detail", "goods_search"],
      path_service_no_menu: ["service_detail", "service_search"],
      path_service: ["home", "fuwuzhida"],
      path_both: ["jianyanjiance", "yibingyijiang", "ershoushangpin", "wiki"],
      daohang: [],
      daohang1: [],
      daohang2: [],
      zixiang: [],
      zixiang_fuwu: [],
      gongye_id: [],
      fuwu_id: [],
      auth_info: "",
      auth_list: [],
      weidu: [],
      total_xi: 0,
      auth_infouid: "",
    };
  },
  computed: {
    is_service_path: function () {
      if (this.path_service.indexOf(this.$route.name) > -1) {
        return 1;
      }

      return 0;
    },

    is_both_path: function () {
      console.log('this.path_both.indexOf' + this.$route.name )
      console.log( ':' + this.path_both.indexOf(this.$route.name) )
      if (this.path_both.indexOf(this.$route.name) > -1) {
        return 1;
      }

      return 0;
    },
    is_product_path_no_menu: function () {
      if (this.path_product_no_menu.indexOf(this.$route.name) > -1) {
        return 1;
      }
      return 0;
    },
    is_service_path_no_menu: function () {
      if (this.path_service_no_menu.indexOf(this.$route.name) > -1) {
        return 1;
      }
      return 0;
    },
    is_product_path: function () {
      if (this.path_product.indexOf(this.$route.name) > -1) {
        return 1;
      }
      return 0;
    },
  },
  methods: {
    //点击跳转到消息列表
    chat_list() {
      if (this.auth_info.status === 101) {
        window.location.href = "/user.html#/login";
      } else {
        window.location.href = "#/chat_new";
      }
    },
    get_infouid() {
      var t = this;
      var aid = localStorage.getItem("uid");
      var url = window.config.api_url + "/user/info?token=" + aid;
      t.axios.get(url).then((res) => {
        t.auth_infouid = res.data.wechat_info.uid;
        this.get_chatlist();
      });
    },
    //聊天室 消息数
    get_chatlist() {
      let t = this;
      if (document.location.protocol == "http:") {
        let url = "http://ws.yi-mix.com/chat/room?uid=" + this.auth_infouid;
        t.axios.get(url).then((res) => {
          t.auth_list = res.data;
          this.weidu = [];
          this.total_xi = 0;
          for (let i = 0; i < t.auth_list.length; i++) {
            t.weidu.push(JSON.parse(t.auth_list[i].unread_total));
          }
          t.weidu.forEach((item) => {
            t.total_xi += item;
          });
          t.$store.commit("set_total_unread", t.total_xi);
        });
      } else {
        let url1 = "https://ws.yi-mix.com/chat/room?uid=" + this.auth_infouid;
        t.axios.get(url1).then((res) => {
          t.auth_list = res.data;
          this.weidu = [];
          this.total_xi = 0;
          for (let i = 0; i < t.auth_list.length; i++) {
            t.weidu.push(JSON.parse(t.auth_list[i].unread_total));
          }
          t.weidu.forEach((item) => {
            t.total_xi += item;
          });
          t.$store.commit("set_total_unread", t.total_xi);
        });
      }
    },
    //顶部导航
    get_dingbu_nav() {
      var t = this;
      var url = window.config.api_url + "/college/home/nav";
      this.axios.get(url).then((res) => {
        t.daohang = res.data;
      });
    },
    //专业服务
    get_fuwu_nav() {
      var t = this;
      var url = window.config.api_url + "/college/home/nav?pid=8";
      this.axios.get(url).then((res) => {
        t.daohang1 = res.data;
        t.daohang1.forEach((item) => {
          t.fuwu_id.push(item.id);
        });
        t.get_fuwu_list();
      });
    },
    //服务子项
    get_fuwu_list() {
      var t = this;
      t.fuwu_id.forEach((item) => {
        let url = window.config.api_url + "/college/home/nav?pid=" + item;
        this.axios.get(url).then((res) => {
          t.zixiang_fuwu.push(res.data);
        });
      });
    },
    //工业产品
    get_gongye_nav() {
      var t = this;
      var url = window.config.api_url + "/college/home/nav?pid=9";
      this.axios.get(url).then((res) => {
        t.daohang2 = res.data;
        t.daohang2.forEach((item) => {
          t.gongye_id.push(item.id);
        });
        t.get_gongye_zx_nav();
      });
    },
    // 工业产品子项
    get_gongye_zx_nav() {
      var t = this;
      t.gongye_id.forEach((item) => {
        let url = window.config.api_url + "/college/home/nav?pid=" + item;
        this.axios.get(url).then((res) => {
          t.zixiang.push(res.data);
        });
      });
    },
    get_info() {
      var t = this;
      var aid = localStorage.getItem("uid");
      var url = window.config.api_url + "/user/info?token=" + aid;
      t.axios.get(url).then((res) => {
        t.auth_info = res.data;
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },

    sousuo_xuanxiang: function (e) {
      this.is_open.sousuo = e;
      console.log(this.is_open.sousuo);
    },
    do_search: function () {
      var path = "";
      this.is_open.search_text = this.is_open.search_text.replace(
        /^(\s+)|(\s+)$/g,
        ""
      );
      if (this.is_open.sousuo == 1) {
        path = "/search";
      }
      if (this.is_open.sousuo == 2) {
        path = "/service/search";
      }
      if (this.is_open.sousuo == 3) {
        path = "/college/novice";
      }
      if (this.is_open.search_text) {
        path += "?title=" + this.is_open.search_text;
      }
      location.href = "/home.html" + "#" + path;
      // this.$router.push(path);
    },
    keyDown(e) {
      if (e.keyCode == 13) {
        this.do_search();
      }
    },
    // getConfig:function(){
    //
    //     var t = this;
    //     // this.config.email = localStorage.getItem('site:email');
    //     // this.config.phone = localStorage.getItem('site:service-phone');
    //     if( !this.config.email || !this.config.phone ){
    //         let url = window.config.api_url+'/user/config/site'
    //         this.axios.get(url).then(res=>{
    //
    //             t.config.email = res.data.site.email;
    //             t.config.phone = res.data.site['service-phone'];
    //             // localStorage.setItem('site:email', t.config.email);
    //             // localStorage.setItem('site:service-phone', t.config.phone);
    //         });
    //
    //     }
    // }
  },

  created: function () {
    this.get_dingbu_nav();
    this.get_fuwu_nav();
    this.get_gongye_nav();
    this.get_info();
    this.get_infouid();
    // this.get_gongye_zx_nav();

    // console.log(this.$route);

    if (this.is_service_path) {
      this.is_open.lanmu = 2;
    }
    if (this.is_product_path) {
      this.is_open.lanmu = 1;
    }

    if (this.$route.path == "/search") {
      this.is_open.sousuo = 1;
    }
    if (this.$route.path == "/service/search") {
      this.is_open.sousuo = 2;
    }

    if (this.$route.query.title) {
      this.is_open.search_text = this.$route.query.title;
    }
    // this.getConfig();
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/home_head.less";

.youfudong {
  float: right;
}
.main_fenlan_neirong1 {
  float: left;
  width: 220px;
  height: 430px;
  background: #ffffff;
  opacity: 0.95;
  position: absolute;
  left: 0px;
  //top: 40px;
  z-index: 20;
  .main_fenlan_neirong_list {
    width: 100%;
    height: 62px;

    .main_fenlan_neirong_list_img {
      width: 20px;
      height: 20px;
      margin-top: 21px;
      margin-left: 17px;
      float: left;
    }

    .main_fenlan_neirong_list_text {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      //float: left;
      /*margin-top: 18px;*/
      margin-left: 13px;
      //line-height: 100px;
    }
  }
}

.pop-list{

  .pop-list-item{

    display: inline-block;
    width: 25%;
    line-height:2;
  }
}
</style>